import createGetFormValues from './selectors/getFormValues';
import plain from './structure/plain';

export default createGetFormValues(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormValues.js
// module id = 1564
// module chunks = 0